<template>
  <SelectComponent
    v-model="publishRelation"
    items="/api/resource/page?field.id=id&field.label=name&field.thumbnail=media.logo.url"
    search
    :label="$t('selectx', { x: $tc('page', 1).toLowerCase() })"
  />
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import SelectComponent from '@kvass/custom-fields/src/Fields/SelectModal'
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  props: {
    data: Object,
    value: Object,
    isSlot: Boolean,
  },
  computed: {
    publishRelation: {
      get() {
        return this.$path('ref', this.value)
      },
      set(newVal, oldVal) {
        this.$emit('input', {
          ref: newVal,
          onModel: !newVal ? null : 'Page',
        })
      },
    },
  },

  components: {
    InputComponent,
    Alert,
    SelectComponent,
  },
}
</script>

<style lang="scss">
[data-field='publishing.relation'] {
  .kvass-selector {
    padding: 0.8rem;
  }
  .field-select-modal__item {
    &-thumbnail {
      width: 3rem;
      object-fit: contain;
    }
  }
}
</style>
